angular.module('SpidApp')

.factory('Stock', [function () {
	var Stock = function (params) {
		params = params || {}
		this.orderable_id	= params.orderable_id
		this.agency_id  	= params.agency_id
		this.label 			= params.label
		this.quantity  		= params.quantity
		this.updated_at		= params.updated_at
	}
	
	Stock.prototype.initFromStockProduct = function (stockProduct, agencyId) {
		this.orderable_id 	= stockProduct.product.id;
		this.agency_id 		= agencyId;
		this.label 			= stockProduct.product.label; // peut-etre mettre le motif de sortie de stock
		this.quantity 		= stockProduct.quantity || 0;
	}
	
	return Stock
}])